module.exports = __webpack_public_path__ + "img/8.3ce54428.jpg";